import PropTypes from 'prop-types';
import React from 'react';

import LoadingBar from 'react-redux-loading-bar';
import { NavLink } from 'react-router-dom';

import { appNamedRoutes, isPermitted } from '../../routes';

import { isASQEnabled, isChatEnabled } from '../../utils/authScopes';
import { hasContentLibraryViewFeature, hasNewCommunicationDashboardFeature } from '../../utils/features';
import { getQueryFromState } from '../../utils/query';

const SubBar = ({ auth, meta }) => {
  const paths = {
    'dashboard': { pathname: appNamedRoutes.partnerRoot, search: getQueryFromState(meta.dashboard, 'dashboard').toString() },
    'asqs': { pathname: appNamedRoutes.asqs, search: getQueryFromState(meta.surveys, 'surveys').toString() },
    'accounts': { pathname: appNamedRoutes.accounts, search: getQueryFromState(meta.accounts, 'accounts').toString() },
    'accountPlayers': { pathname: appNamedRoutes.accountPlayers, search: getQueryFromState(meta.accountPlayers, 'accountPlayers').toString() },
    'settings': { pathname: appNamedRoutes.settings },
    'groupcohortsReport': { pathname: appNamedRoutes.groupcohortsReport, search: getQueryFromState(meta.groupCohorts, 'groupCohorts').toString() },
    'library': { pathname: appNamedRoutes.library },
    'administration': { pathname: appNamedRoutes.administration },
    'communicationDashboard': { pathname: appNamedRoutes.communicationIndividuals }
  };

  return (
    <div className="cs-bg--light u-navbar-padding">
      <div className="o-subbar row align-middle">
        <ul className="o-subbar__menu">
          {isPermitted('dashboard', auth) &&
            <li>
              <NavLink to={paths.dashboard} activeClassName='o-subbar__item--active' className='o-subbar__item'>Dashboard</NavLink>
            </li>
          }
          {isPermitted('accountPlayers', auth) &&
            <li>
              <NavLink to={paths.accountPlayers} activeClassName='o-subbar__item--active' className='o-subbar__item'>Children</NavLink>
            </li>
          }
          {isPermitted('accounts', auth) &&
            <li>
              <NavLink to={paths.accounts} activeClassName='o-subbar__item--active' className='o-subbar__item'>Adults</NavLink>
            </li>
          }
          {isPermitted('groupcohortsReport', auth) &&
            <li>
              <NavLink to={paths.groupcohortsReport} activeClassName='o-subbar__item--active' className='o-subbar__item'>Group&Cohort Report</NavLink>
            </li>
          }
          {hasContentLibraryViewFeature(auth) &&
            <li>
              <NavLink to={paths.library} activeClassName='o-subbar__item--active' className='o-subbar__item'>Library</NavLink>
            </li>
          }
          {isASQEnabled(auth) && isPermitted('asqs', auth) &&
            <li>
              <NavLink to={paths.asqs} activeClassName='o-subbar__item--active' className='o-subbar__item'>ASQ Dashboard</NavLink>
            </li>
          }
          {isPermitted('administration', auth) && !!auth.partnerId &&
            <li>
              <NavLink to={paths.administration} activeClassName='o-subbar__item--active' className='o-subbar__item'>Administration</NavLink>
            </li>
          }
          {isPermitted('accountPlayers', auth) && hasNewCommunicationDashboardFeature(auth) &&
              <li>
                <NavLink to={paths.communicationDashboard} activeClassName='o-subbar__item--active' className='o-subbar__item'>Messaging</NavLink>
              </li>
          }
          {isPermitted('settings', auth) &&
            <li>
              <NavLink to={paths.settings} activeClassName='o-subbar__item--active' className='o-subbar__item'>Settings</NavLink>
            </li>
          }
        </ul>
      </div>
      <LoadingBar style={{ backgroundColor: '#31ccff', height: '3px' }} />
    </div>
  );
}

SubBar.propTypes = {
  auth: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default SubBar;
